import "@/App.css";
import PromoBanner from "@/components/PromoBanner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import ScopeSection from "@/components/ScopeSection";
import ChronicCare from "@/components/ChronicCare";
import DermaGenSection from "@/components/DermaGenSection";
import Blog from "@/components/Blog";
import Gallery from "@/components/Gallery";
import BookingSection from "@/components/BookingSection";
import ContactMap from "@/components/ContactMap";
import StaffPortal from "@/components/StaffPortal";
import Footer from "@/components/Footer";
import OrbAssistant from "@/components/OrbAssistant";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="min-h-screen bg-brand-cream font-body text-foreground">
      <PromoBanner />
      <Header />
      <main>
        <Hero />
        <Services />
        <ScopeSection />
        <ChronicCare />
        <DermaGenSection />
        <Blog />
        <Gallery />
        <BookingSection />
        <ContactMap />
        <StaffPortal />
      </main>
      <Footer />
      <OrbAssistant />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
